// @flow
import { useHistory } from "react-router";
import { type QuestionProps } from "../components/MultiStageForm";
import {
  Heading,
  BackButton,
  QuestionWrapper,
  ImageCardOption,
} from "../components";

export const NotInServicedAreaNextStep = ({
  next,
}: QuestionProps<"notInServicedAreaNextStep">) => {
  const history = useHistory();
  return (
    <QuestionWrapper
      dataTest="not-in-serviced-area-next-step"
      next={() => undefined}
    >
      <BackButton
        prev={() => {
          history.push("/");
        }}
      />
      <Heading>
        Our agents are not in your area yet, but in the meantime...
      </Heading>
      <ImageCardOption
        onClick={() => next("ACCESS_DATA")}
        heading="Access our unique data and insights on your local market"
        dataTest="not-in-serviced-area-access-tools"
      />
      <ImageCardOption
        linkTo="/blog/posts/the-nested-guide-to-moving-home"
        heading="Read the ultimate guide to moving home"
      />
    </QuestionWrapper>
  );
};
